export function shouldDiscardEndExperienceImmediately(promptTrigger, history) {
  var _history$entries;
  var isPreConfiguredPrompt = promptTrigger !== 'generate'; // like immediate 'improve writing' from toolbar
  var isInitialPrompt = (history === null || history === void 0 || (_history$entries = history.entries) === null || _history$entries === void 0 ? void 0 : _history$entries.length) === 1;
  return isPreConfiguredPrompt && isInitialPrompt;
}